import React from "react"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import CardSlideshow from "./card-slideshow"
import Bar from "./bar"
import { articles } from "../data/guides"

const Services = () => {
  const services = [
    {
      id: 5,
      url: "/use-cases/school-holiday-screen-time/",
      title: "A holiday with room beyond screens",
      description:
        "Plan gaming, offline time and rest with practical approaches for younger children, tweens and teenagers.",
    },
    {
      id: 1,
      url: "/use-cases/weekly-classroom-calendar/",
      title: "A classroom week parents can follow",
      description:
        "Put reading, maths, PE, library time, and assembly in one visual schedule. Publish a read-only calendar for families.",
    },
    {
      id: 2,
      url: "/use-cases/after-school-activity-schedule-ai/",
      title: "After-school plans from a simple request",
      description:
        "Describe homework, sport, and music practice in Magic Generate. Review the suggested dates and times before adding events.",
    },
    {
      id: 3,
      url: "/use-cases/visual-homeschool-weekly-schedule/",
      title: "Visual homeschool planning",
      description:
        "Arrange subjects and learning activities with recognisable icons. Save useful activities to reuse as you build your week.",
    },
    {
      id: 4,
      url: "/use-cases/school-club-schedule/",
      title: "School club schedules",
      description:
        "Give families a link to session times and event details. Choose an optional password when publishing your calendar.",
    },
  ]

  return (
    <Grid
      id="features"
      container
      spacing={3}
      style={{
        textAlign: "center",
        minHeight: 200,
        padding: "32px 10px 48px",
      }}
    >
      <Grid
        item
        xs={12}
        container
        direction="column"
        justify="center"
        alignItems="center"
      >
        <Typography variant="h5" component="h2">
          A routine that works for you.
        </Typography>
        <Bar />
        <Typography
          variant="subtitle1"
          color="textSecondary"
          style={{ margin: 30, maxWidth: 680 }}
        >
          Whether you’re planning school holidays, organising after-school
          activities, teaching or running a club, bring your week together and
          make space for good habits.
        </Typography>
      </Grid>

      <CardSlideshow
        items={services.map(service => ({
          ...service,
          image: articles.find(article => article.url === service.url)!.image,
        }))}
        label="Routines for you"
      />

      <Grid item xs={12}>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          href="/guides/?group=Use%20cases"
        >
          Explore more routines
        </Button>
      </Grid>
    </Grid>
  )
}
export default Services
